const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'SET_SHOPPER':
      return { ...state, ...action.shopper };
    case 'CLEAR_SHOPPER':
      return initialState;
    default:
      return state;
  }
}
